import { Div, RefComponentBase, Label } from "@tblabs/truffle";


export class ControlGroup extends Div
{
    constructor(label: string, input: RefComponentBase<any, any>)
    {
        super("control-group");

        this.Append(
            new Label(label, label),
            input.Attribute("id", label)
        );
    }
}
